import styled from 'styled-components';
import { GleamWrapperMixin } from '../../mixins/components/GleamWrapperMixin';

// TODO: In 9v, abstract to own component and directory
export var StyledGleamWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledGleamWrapper",
  componentId: "c11n-8-107-0__sc-m5v26w-0"
})(["", ""], GleamWrapperMixin);